import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { getDataWithDotNet } from "../../../newApis/dotNetApiMethods";
import { IPaginatedResponse } from "../../../interfaces/response";

export type TUserQuery = {
  role_id: string;
  search_value?: string;
  Page: string;
  PageSize: string;
  user_type: string;
};

export interface IAdminUser {
  id: number;
  last_login: string | null;
  is_super_user: boolean;
  first_name: string;
  last_name: string;
  is_staff: boolean;
  is_active: boolean;
  date_joined: string;
  phone: string;
  username: string | null;
  user_type: string;
  email: string;
  email_confirmed: number;
  address: string;
  roles: string[];
  sso_user_id: string;
}

const getAllAdminUsers = async (
  query: TUserQuery,
): Promise<IPaginatedResponse<IAdminUser[]>> => {
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.ADMIN_USERS}?${new URLSearchParams(query).toString()}`,
  );
  return data;
};

export default function useAllAdminUsers(query: TUserQuery) {
  return useQuery<IPaginatedResponse<IAdminUser[]>, Error>(
    [query, "getAllAdminUsers"],
    getAllAdminUsers,
    {
      refetchOnWindowFocus: false,
    },
  );
}
